import React from 'react'
import PropTypes from 'prop-types'

const PageHeader = ({
  title,
  subtitle,
  backgroundImage,
  large = false,
  className = ''
}) => {
  // If no background image, default to is-primary for consistent green theme
  const heroStyle = backgroundImage ? '' : 'is-primary'
  const headerClass = `hero ${large ? 'is-fullheight' : 'is-medium'} ${heroStyle} page-header ${backgroundImage ? 'has-background-image' : ''} ${className}`

  return (
    <section
      className={headerClass}
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}}
    >
      <div className="hero-body">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-10-mobile is-8-tablet is-6-desktop has-text-centered animate-fade-in-up">
              <h1 className="title is-1-desktop is-2-tablet is-3-mobile has-text-weight-bold page-header-title">
                {title}
              </h1>
              {subtitle && (
                <h2 className="subtitle is-4-desktop is-5-tablet is-6-mobile page-header-subtitle mt-4">
                  {subtitle}
                </h2>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

PageHeader.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
  subtitle: PropTypes.string,
  backgroundImage: PropTypes.string,
  large: PropTypes.bool,
  className: PropTypes.string
}

export default PageHeader
